<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button (click)="scrollToTop()" type="button" class="flex flex-row justify-center items-center p-2 border-blue-800 border-2 rounded-full shadow-sm text-blue-800 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
    </svg>
  </button>
</div>